/** Endpoints #1-#3 — login, logout, boot gate (ARCHITECTURE §5.1, §10.1). */
import { z } from 'zod';
/** #1 `POST /api/auth/login` */
export const LoginBodySchema = z.strictObject({
    password: z.string().min(1).max(512),
});
/** Session cookie name (§10.1). */
export const SESSION_COOKIE = 'lw_session';
//# sourceMappingURL=auth.js.map